module.exports = __webpack_public_path__ + "img/big-ship-wreck-2.f11b79e9.png";